// QESG ASSESSMENT 중 협력사 화면의 '평가 결과' 관련 Store
import Vue from 'vue';
import axios from '@core_utils/api/_axios';
import commonLogout from '@core_utils/common-logout';
import { thousandSepratorRemover } from '@core_utils/util';

const industry_scores = {
    namespaced: true,
    state: {
        industry_info: {
            // qe_industry_id: 10,
            // code: 'CON',
            // name: '건설/엔지니어링'
            // gics_code: 201030,
            // gics_group: "자본재",
            // gics_industry: "건설과 엔지니어링",
            // gics_sector: "산업",
            // kor_sm_code: "353",
            // kor_sm_name: "증기, 냉ㆍ온수 및 공기 조절 공급업"
        },
        category1_score: [ // pandas로 읽어오거나, Getters로 만들기
            {category1_name: '환경', score: 0}, 
            {category1_name: '인권 및 노동', score: 0}, 
            {category1_name: '윤리 및 지배구조', score: 0}, 
            {category1_name: '제품 및 서비스 책임', score: 0}
        ],
        category2_score: [ // pandas로 읽어오기
            { category1_name: '환경', category2_name: '환경경영', score: 66, type:'core', description: '기업 및 조직은 환경목표를 수립하고 환경경영 조직을 구성하여 환경경영체계를 운영함으로써 사업 활동으로 인해 발생하는 환경 영향을 최소화할 수 있도록 적극적으로 노력해야 합니다.'}, 
            { category1_name: '환경', category2_name: '에너지 및 온실가스', score: 75, type:'core', description: '에너지 소비는 기업 및 조직의 탄소발자국과 직접 연계됩니다. 에너지 소비로 인한 온실가스 배출은 기후변화의 주 요인으로 대한민국을 포함한 UN 회원국은 ‘유엔기후변화협약’을 기반으로 온실가스 배출량 감축을 위해 다양한 규정과 시스템을 운영하고 있습니다. 기업 및 조직은 에너지 효율 관리, 신재생에너지 도입 등을 기반으로 온실가스 배출량을 감축하고 탄소발자국과 환경 성과를 관리할 수 있습니다.'},
            { category1_name: '인권 및 노동', category2_name: '노동관행', score: 92, type:'core', description: '노동관행은 고용 관행, 근로시간, 임금 및 보상, 노사관계, 비차별 등 노동자의 기본권에 대한 보호 원칙을 기반으로 합니다. 기업 또는 조직은 국제노동기준 및 노동법을 준수하고 이에 대한 내부 감시와 관리가 필요합니다.'},
            { category1_name: '인권 및 노동', category2_name: '안전 및 보건', score: 82, type:'core', description: '안전 및 보건은 근로자의 참여도 및 생산성과 직결됩니다. 기업 및 조직은 조직 및 정책을 규정하고 산업안전보건 지표를 관리하여 안전보건경영을 추진함으로써 인적 자본 손실을 최소화하고, 생산성을 향상할 수 있습니다. '},
            { category1_name: '윤리 및 지배구조', category2_name: '윤리경영', score: 76, type:'core', description: '기업 및 조직은 윤리규정을 기반으로 내부 구성원의 행동 준칙을 마련하고, 윤리 신고 채널 운영,  모니터링을 통해 윤리경영을 실천할 수 있습니다. 반부패, 공정경쟁, 이해관계 충돌 방지 등이 관리 범위에 포함됩니다.'},
            { category1_name: '윤리 및 지배구조', category2_name: 'ESG 관리 및 정보공개', score: 50, type:'core', description: '기업 및 조직은 정기적으로 비재무적 성과를 검토하고 정보를 공개함으로서 사회책임에 대한 이해관계자의 요구를 충족할 수 있습니다. GRI Standards등 국제 표준 기반의 양질의 정보 공개는 ESG 정보에 대한 접근성과 비교가능성을 향상하여 이해관계자 의사결정에 긍정적 영향을 미칩니다.'},
            { category1_name: '제품 및 서비스 책임', category2_name: '정보보호', score: 70, type:'innovation', description: '데이터 및 정보 시스템이 전 산업의 기반 인프라로 자리함에 따라 기업 및 조직에 요구되는 정보보호, 보안, 개인정보 관리의 중요성이 더욱 증가하였습니다. 기업 및 조직은 정보보안 체계를 갖추고 정기적으로 보안 시스템을 모니터링하여 리스크를 사전에 예방함으로써 경쟁력을 확보할 수 있습니다.'},
        ],
        category3_score: [],
        questions_materiality: [ // pandas로 읽어오기
            { category1_name: '환경', category2_code: '', category2_name: '환경경영', stakeholder_impact: 6, business_impact: 3, alphabet_code: 'A', type:'core'}, 
            { category1_name: '환경', category2_code: '', category2_name: '에너지 및 온실가스', stakeholder_impact: 6, business_impact: 5, alphabet_code: 'B', type:'core'},
            { category1_name: '인권 및 노동', category2_code: '', category2_name: '노동관행', stakeholder_impact: 5, business_impact: 5, alphabet_code: 'C', type:'core'},
            { category1_name: '인권 및 노동', category2_code: '', category2_name: '인권', stakeholder_impact: 2, business_impact: 4, alphabet_code: 'D', type:'core'},
            { category1_name: '인권 및 노동', category2_code: '', category2_name: '안전 및 보건', stakeholder_impact: 4, business_impact: 4, alphabet_code: 'E', type:'core'},
            { category1_name: '윤리 및 지배구조', category2_code: '', category2_name: '윤리경영', stakeholder_impact: 6, business_impact: 6, alphabet_code: 'F', type:'core'},
            { category1_name: '윤리 및 지배구조', category2_code: '', category2_name: '지배구조', stakeholder_impact: 5, business_impact: 4, alphabet_code: 'G', type:'big'}, // company size에 따라 안보이는 것은 type: 'big'
            { category1_name: '윤리 및 지배구조', category2_code: '', category2_name: 'ESG 경영 및 정보공개', stakeholder_impact: 5, business_impact: 3, alphabet_code: 'H', type:'core'},
            { category1_name: '환경', category2_code: '', category2_name: '용수 및 폐수', stakeholder_impact: 0, business_impact: 0, alphabet_code: '', type:'innovation', detail: ''}, // 산업 혁신 지표는 type: 'innovation'
            { category1_name: '환경', category2_code: '', category2_name: '폐기물 및 유해물질', stakeholder_impact: 0, business_impact: 0, alphabet_code: '', type:'innovation', detail: ''},
            { category1_name: '환경', category2_code: '', category2_name: '대기 질', stakeholder_impact: 0, business_impact: 0, alphabet_code: '', type:'innovation', detail: ''},
            { category1_name: '제품 및 서비스 책임', category2_code: '', category2_name: '정보보호', stakeholder_impact: 8, business_impact: 7, alphabet_code: 'I', type:'innovation', detail: ''},
        ],
        is_materiality_loaded: false,
        company_info: { name: '컴퍼니에이(주)', code: '349-86-01679', address: '서울 종로구 삼봉로 57, 호수빌딩', employees: '55', revenue: '1190300'},
        assessment_info: { company_id: '1', campaign_id: '123', engaged_date: '2021-02-02', engaged_campaign: '2021 - 2회차(하반기)', status_code: 'in_progress' },
        total_score: 0,
        total_score_object: {},
        bm_distribution: [{ section_percent_of_companies: 0 }],
        my_code: '',
        my_rate: '',
        sh_rate: '',
        num_of_benchmark_companies: 0,
        category1_distribution: [],
        is_bm_distribution_loaded: false,
        category1_benchmark: [],
        credit_rate: 'BB-',
        alter_rate: 'bb', // 모형등급
        // credit_rate_info: { evd_date: '2020.01.01', evd_validate_date: '2020.12.31'},
        industry_universe: [],
        all_factors: [],
        minus_factors: [],
        e_factors: [],
        s_factors: [],
        g_factors: [],
        r_factors: [],
        is_qe_factors_loaded: false,
        bm_scores: {},
        is_bm_scores_loaded: false,
        e_audit_reviews: [],
        s_audit_reviews: [],
        g_audit_reviews: [],
        r_audit_reviews: [],
        is_audit_reviews_loaded: false,
        qe_evaluate_result: {},
        is_qe_evaluate_loaded: false,
        key_figures: {},
        is_key_figure_loaded: false,
        taxonomy_accepted: false,
        score_history: [],
        is_score_history_loaded: false,
        esg_rating_set: ['ESG-7', 'ESG-6', 'ESG-5', 'ESG-4', 'ESG-3', 'ESG-2', 'ESG-1'], // 수정금지, 업데이트 되지 않는 고정 데이터
        qesg_rating_set: ['C', 'B','BB', 'BBB', 'A', 'AA', 'AAA'], // 수정금지, 업데이트 되지 않는 고정 데이터
        shinhan_rating_set: ['미흡', '보통', '양호', '우수'],// 수정금지, 업데이트 되지 않는 고정 데이터
        part_rating_set: { // 수정금지, 업데이트 되지 않는 고정 데이터
            '환경': ['E-7', 'E-6', 'E-5', 'E-4', 'E-3', 'E-2', 'E-1'],
            '인권 및 노동': ['S-7', 'S-6', 'S-5', 'S-4', 'S-3', 'S-2', 'S-1'],
            '윤리 및 지배구조': ['G-7', 'G-6', 'G-5', 'G-4', 'G-3', 'G-2', 'G-1']
        },
        category1s:[
            {   
                name:'환경경영',
                name_e: 'Environment and Management', 
                ab: 'E' 
            },
            {   
                name:'인권경영',
                name_e:'Human-Rights Management', 
                ab: 'HR' 
            },
            {   
                name:'윤리경영',
                name_e:'Ethics Management', 
                ab: 'Eth' 
            },
            {   
                name:'안전보건경영',
                name_e: 'Safety and Health Management',
                ab: 'SH'
            }
        ],
        risk_score: null,
        risk_lv: null,
        risk_factors: {}
    },

    mutations: {
        update_company_info(state, new_company_obj){
            state.company_info = new_company_obj;
            state.credit_rate = new_company_obj.credit_rating;
            if (new_company_obj.rating_scheme =='모형등급'){
                state.credit_rate = '';
            }
            state.alter_rate = new_company_obj.alter_rating;
        },
        update_assessment_info(state, new_assess_obj){
            // console.log(new_assess_obj)
            state.assessment_info = new_assess_obj;
        },
        update_industry_info(state, new_industry_obj){
            state.industry_info = new_industry_obj;
        },
        update_industry_universe(state, new_industry_list){
            state.industry_universe = new_industry_list;
        },
        update_questions_materiality(state, new_materiality_list){
            state.questions_materiality = new_materiality_list;
        },
        update_materiality_loaded(state, flag){
            state.is_materiality_loaded = flag;
        },
        update_category1_score(state, new_array){
            // let temp1 = [...state.category1_score]
            // for (let i=0; i<new_array.length; i++){
            //     let idx = new_array.findIndex(x=> x.category1_name == temp1[i].category1_name)
            //     if(new_array[idx].score!=null){
            //         if (state.assessment_info.engaged_campaign=='2021 - 1회차(상반기)'){
            //             temp1[i].score = Math.floor(new_array[idx].score)
            //             temp1[i].weight_rate = Math.floor(new_array[idx].weight_rate*100)
            //         }else {
            //             temp1[i].score = Math.round(new_array[idx].score)
            //             temp1[i].weight_rate = Math.round(new_array[idx].weight_rate*100) 
            //         }
            //         temp1[i].category1_name_e = new_array[idx].category1_name_e
            //     }else {
            //         temp1[i].score = new_array[idx].score
            //         temp1[i].weight_rate = new_array[idx].weight_rate
            //         temp1[i].category1_name_e = new_array[idx].category1_name_e
            //     }
            // }
            state.category1_score = new_array;
        },
        update_category2_score(state, new_2_array){
            let temp2 = [...new_2_array];
            temp2.forEach(z => {
                if(z.score!=null){
                    if (state.assessment_info.engaged_campaign=='2021 - 1회차(상반기)'){
                        z.score = Math.floor(z.score);
                    }else z.score = Math.round(z.score);
                }else z.score = z.score;
            });
            state.category2_score = temp2;
        },
        update_category3_score(state, new_3_array){
            let temp3 = [...new_3_array];
            temp3.forEach(z => {
                if(z.score!=null){
                    if (state.assessment_info.engaged_campaign=='2021 - 1회차(상반기)'){
                        z.score = Math.floor(z.score);
                    }else z.score = Math.round(z.score);
                }else z.score = z.score;
            });
            state.category3_score = temp3;
        },
        update_total_score(state, new_score){
            state.total_score = Math.round(new_score*10)/10;
        },
        update_bm_distribution(state, new_obj){
            // console.log(new_obj);
            state.bm_distribution = new_obj.distribution;
            state.num_of_benchmark_companies = new_obj.num_of_companies;
            state.category1_distribution = new_obj.category1_distribution;
            state.category1_benchmark = new_obj.column_stats;
            state.is_bm_distribution_loaded = true;
        },
        update_qe_factors(state, new_array){      
            let temp_e = [...state.e_factors];
            temp_e = new_array.filter(x => x.category1_name=='환경');
            let temp_s = [...state.s_factors];
            temp_s = new_array.filter(x => x.category1_name=='인권 및 노동');
            let temp_g = [...state.g_factors];
            temp_g = new_array.filter(x => x.category1_name=='윤리 및 지배구조');
            let temp_r = [...state.r_factors];
            temp_r = new_array.filter(x => x.category1_name=='제품 및 서비스 책임');
            let temp_minus = [...state.minus_factors];
            temp_minus = new_array.filter(x => x.icon=='minus_factor');

            state.e_factors = temp_e;
            state.s_factors = temp_s;
            state.g_factors = temp_g;
            state.r_factors = temp_r;
            state.minus_factors = temp_minus;
            state.all_factors = new_array;
            state.is_qe_factors_loaded = true;
        },
        update_is_qe_factors_loaded(state, flag){
            state.is_qe_factors_loaded = flag;
        },
        add_or_update_bm_scores(state, new_obj){
            let new_bm_score = {...state.bm_scores};
            let bm_obj = {};            
            Vue.set(bm_obj, new_obj.campaign_id, new_obj);
            new_bm_score[new_obj.campaign_id] = new_obj;
            // console.log(new_bm_score);
            state.bm_scores = new_bm_score;
            state.is_bm_scores_loaded = true;
        },
        update_bm_scores_loaded(state, flag){
            state.is_bm_scores_loaded = flag;
        },
        update_is_bm_distribution_loaded(state, flag){
            state.is_bm_distribution_loaded = flag;
        },
        reset_industry_scores(state, flag){
            if (flag == true){
                // state.category1_score = [{category1_name: '환경', score: 59}, {category1_name: '인권 및 노동', score: 72}, {category1_name: '윤리 및 지배구조', score: 53}, {category1_name: '제품 및 서비스 책임', score: 79}]
                // state.category2_score = [{ category1_name: '환경', category2_name: '환경경영', score: 66, type:'core', description: '기업 및 조직은 환경목표를 수립하고 환경경영 조직을 구성하여 환경경영체계를 운영함으로써 사업 활동으로 인해 발생하는 환경 영향을 최소화할 수 있도록 적극적으로 노력해야 합니다.'}]
                state.questions_materiality = [{ category1_name: '환경', category2_code: '', category2_name: '환경경영', stakeholder_impact: 6, business_impact: 3, alphabet_code: 'A', type:'core'}];
                state.company_info = { name: '컴퍼니에이(주)', code: '349-86-01679', address: '서울 종로구 삼봉로 57, 호수빌딩', employees: '55', revenue: '1190300'};
                state.assessment_info = { company_id: '0', campaign_id: '123', engaged_date: '2021-02-02', engaged_campaign: '2021 - 2회차(하반기)', status_code: 'in_progress' };
                state.total_score = 0;
                state.my_code = '';
                state.my_rate = '';
                state.is_bm_distribution_loaded = false;
                state.is_bm_scores_loaded = false;
                state.e_factors = [];
                state.s_factors = [];
                state.g_factors = [];
                state.r_factors = [];
                state.all_factors = [];
            }
        },
        update_audit_reviews(state, new_list){
            let temp_e_review = [...state.e_audit_reviews];
            temp_e_review = new_list.filter(x => x.category1_name =='환경');
            let temp_s_review = [...state.s_audit_reviews];
            temp_s_review = new_list.filter(x => x.category1_name =='인권 및 노동');
            let temp_g_review = [...state.g_audit_reviews];
            temp_g_review = new_list.filter(x => x.category1_name =='윤리 및 지배구조');
            let temp_r_review = [...state.r_audit_reviews];
            temp_r_review = new_list.filter(x => x.category1_name =='제품 및 서비스 책임');
            state.e_audit_reviews = temp_e_review;
            state.s_audit_reviews = temp_s_review;
            state.g_audit_reviews = temp_g_review;
            state.r_audit_reviews = temp_r_review;
            state.is_audit_reviews_loaded = true;
        },
        update_qe_evaluate_result(state, ev_set){
            if (!Object.keys(state.qe_evaluate_result).length) {
                state.qe_evaluate_result = ev_set;
            } else {
                Object.keys(ev_set).forEach(_ev_sub_code => {
                    state.qe_evaluate_result[_ev_sub_code] = ev_set[_ev_sub_code];
                });
            }
        },
        update_qe_evaluate_result_loaded(state, flag){
            state.is_qe_evaluate_loaded = flag;
        },
        update_key_figures (state, new_obj) {
            state.key_figures = new_obj;
        },
        update_key_figure_loaded(state, flag){
            state.is_key_figure_loaded = flag;
        },
        update_check_taxonomy(state, flag){
            state.taxonomy_accepted = flag;
        },
        update_score_history(state, new_arr){
            let temp_arr = [];
            for(let i=0; i<new_arr.length; i++){
                if(new_arr[i].code=='success'){
                    temp_arr.push(new_arr[i]);
                }
            }
            // console.log(temp_arr);
            state.score_history = temp_arr;
        },
        update_score_history_loaded(state, flag){
            state.is_score_history_loaded = flag;
        },
        update_total_score_object(state, new_obj){
            state.total_score_object = new_obj;
            state.my_code = new_obj.my_code;
            state.my_rate = new_obj.my_rate;
            state.sh_rate = new_obj.sh_rate;
        },
        update_qe_risks(state, new_obj){
            // console.log(new_obj)
            state.risk_score = new_obj.total_score;
            state.risk_lv = new_obj.rate;
            state.risk_factors = new_obj.category2;
        },
        initiate_qe_risks(state){
            state.risk_score = null;
            state.risk_lv = null;
            state.risk_factors = {};
        }
    },
    getters: {
        hashed_score(state){
            let temp_all = [...state.category2_score];
            let temp_obj = {};
            for (let i=0; i<temp_all.length; i++){
                if (temp_obj.hasOwnProperty(temp_all[i].category1_name)==true){
                    temp_obj[temp_all[i].category1_name].push(temp_all[i]);
                }
                else Vue.set(temp_obj, temp_all[i].category1_name, [temp_all[i]]);
            }     
            return temp_obj;            
        },
        hashed_score_category1(state){
            let temp_all = [...state.category1_score];
            let temp_obj = {};
            for (let i=0; i<temp_all.length; i++){
                Vue.set(temp_obj, temp_all[i].category1_name, temp_all[i]);
            }     
            return temp_obj;            
        },
        hashed_core_qs(state){
            let cores = state.questions_materiality.filter(x => x.type!='innovation');
            let core_obj = {};
            for (let i=0; i<cores.length; i++){
                if (core_obj.hasOwnProperty(cores[i].category1_name)==true){
                    core_obj[cores[i].category1_name].push(cores[i]);
                }
                else Vue.set(core_obj, cores[i].category1_name, [cores[i]]);
            }    
            return core_obj;
        },
        hashed_innovation_qs(state){
            let innos = state.questions_materiality.filter(x => x.type=='innovation');
            let inno_obj = {};
            for (let i=0; i<innos.length; i++){
                if (inno_obj.hasOwnProperty(innos[i].category1_name)==true){
                    inno_obj[innos[i].category1_name].push(innos[i]);
                }
                else Vue.set(inno_obj, innos[i].category1_name, [innos[i]]);
            } 
            return inno_obj;
        },
        hashed_rating(state){
            let temp_arr = [...state.bm_distribution];
            let temp_obj = {};
            for (let i=0; i<temp_arr.length; i++){
                Vue.set(temp_obj, temp_arr[i].rate, temp_arr[i]);
            }
            return temp_obj;
        },
        hashed_code(state){
            let temp_arr = [...state.bm_distribution];
            let temp_obj = {};
            for (let i=0; i<temp_arr.length; i++){
                Vue.set(temp_obj, temp_arr[i].code, temp_arr[i]);
            }
            return temp_obj;
        },
        hashed_cat1_rating(state){
            let temp_arr = [...state.category1_distribution];
            let temp_obj = {};
            for (let i=0; i<temp_arr.length; i++){
                let new_obj = {
                    my_rate: temp_arr[i].my_rate,
                    my_code: temp_arr[i].my_code,
                    distribution : temp_arr[i].distribution
                };
                Vue.set(temp_obj, temp_arr[i].category1_name, new_obj);
            }
            return temp_obj;
        },
    },
    actions: {
        async readCompanyInfo ({ commit }, company_id) {
            const response = await axios.get('/read_qe_cr_company_info', { params: { company_id } });
            commit('update_company_info', response.data);
        },
        async readAssessmentInfo ({ commit }, { company_id, campaign_id }){
            const response = await axios.get('/read_qe_cr_assessment_info', { params: { company_id: company_id, campaign_id: campaign_id }}); 
            commit('update_assessment_info', response.data);
        },
        async readIndustryInfo ({ commit }, { company_id, campaign_id }){
            const response = await axios.get('/read_qe_cr_industry', { params: { company_id: company_id, campaign_id: campaign_id }}); 
            commit('update_industry_info', response.data);
        },
        async readAllIndustryStandards ({ commit }, user_id) {
            try {
                const response = await axios.get('/read_all_industry_standards', { params: { user_id }}); 
                commit('update_industry_universe', response.data);    
            } catch (error) {
                if (error.response) {
                    if (error.response.status === 401) {
                        await commonLogout();
                    }
                }
            }
        },
        async readMateriality ({ commit }, { campaign_id }) {
            const response = await axios.get('/read_materiality', {
                params: { campaign_id:campaign_id }
            }); 
            commit('update_questions_materiality', response.data);
            commit('update_materiality_loaded', true);
        },
        async readQeCrFactors ({ commit }, { company_id, campaign_id, project_code }) {
            const response = await axios.get('/read_qe_cr_factors', {
                params: { company_id, campaign_id, project_code }
            });
            commit('update_qe_factors', response.data);
        },
        async readQeCrScores ({ commit }, { company_id, campaign_id, risk_lv, project_code }) {
            // readQeBmScores와는 달리, 개별 보고서에서 사용됨
            /**
             * 종종 500 error를 던지므로 주의요망
             */
            try {
                const response = await axios.get('/read_qe_cr_scores', {
                    params: { company_id, campaign_id, risk_lv, project_code }
                });

                commit('update_category1_score', response.data.category1_score);
                commit('update_category2_score', response.data.category2_score);
                commit('update_category3_score', response.data.category3_score);
                commit('update_total_score', response.data.total_score[0].total_score);
                commit('update_total_score_object', response.data.total_score[0]);
                commit('update_bm_distribution', response.data.benchmark);    
            } catch (error) {
                if (error.response) {
                    console.log(' ~ error.response => ', error.response);
                }
            }
        },
        async readQeBmScores ({ commit, rootState }, { company_id, campaign_ids }) {
            try {
                // readQeCrScores와 용도가 달라서 분리함
                const path = rootState.backend_host + '/read_qe_cr_history';
                let promises = [];
                campaign_ids.forEach(item => {
                    promises.push(axios.get(path, {params: { company_id, campaign_id: item}}));
                });

                const responses = await Promise.all(promises);
                let response_arr = responses.map(x=> x.data.history_set.score_obj);
                response_arr.forEach(y => commit('add_or_update_bm_scores', y),);    
            } catch (error) {
                console.log(error);   
            }
        },
        async readAuditReview ({ commit }, { company_id, campaign_id }) {
            try {
                const response = await axios.get('/read_qe_review_results', {
                    params: { company_id, campaign_id }
                });
                commit('update_audit_reviews', response.data);   
            } catch (error) {
                console.log(error);
            }
        },
        async readQeEvaluateResult ({ commit }, { company_id, campaign_id, project_code, sub_code, sub_codes }) {
            try {
                commit('update_qe_evaluate_result_loaded', false);
                if (sub_codes) {
                    sub_codes = sub_codes.join(',');
                }

                const _res_ev_result = await axios.get('/v2/scoring', {
                    params: { company_id, campaign_id, project_code, sub_code, sub_codes, live : true }
                });

                
                let _ev_result_data = [];
                if (_res_ev_result.data?.scoring?.scoring_pd && _res_ev_result.data?.scoring?.scoring_pd.length) {
                    _ev_result_data = [ ..._ev_result_data, ..._res_ev_result.data?.scoring?.scoring_pd ];
                }

                if (_res_ev_result.data?.risk?.risk_pd && _res_ev_result.data?.risk?.risk_pd.length) {
                    _ev_result_data = [ ..._ev_result_data, ..._res_ev_result.data?.risk?.risk_pd ];
                }

                if (!_ev_result_data.length) {
                    commit('update_qe_evaluate_result', {});
                } else {
                    const _ev_result_data_by_sub_code = _ev_result_data.reduce((_ev_results, _ev_result) => {
                        if (!_ev_results[_ev_result.sub_code]) _ev_results[_ev_result.sub_code] = [];
                        _ev_results[_ev_result.sub_code].push(_ev_result);
                        return _ev_results;
                    }, {});

                    if (sub_codes) {
                        sub_codes.split(',').forEach(sub_code => {
                            if (!_ev_result_data_by_sub_code[sub_code]) _ev_result_data_by_sub_code[sub_code] = [];
                        });
                    } else if (sub_code) {
                        if (!_ev_result_data_by_sub_code[sub_code]) _ev_result_data_by_sub_code[sub_code] = [];
                    }

                    commit('update_qe_evaluate_result', _ev_result_data_by_sub_code);
                }

                commit('update_qe_evaluate_result_loaded', true);
            } catch (error) {
                throw error;
            }
        },
        async saveQeEvaluateResult ({ dispatch }, { project_code, campaign_id, company_id, sub_code, ev_list, from_v3 }) {
            try {
                /**
                 * ev_list = { ev_id, author_id, satisfied, not_applicable, comment }
                 */
                await axios.put('/v2/save_audit', { company_id, campaign_id, project_code, ev_list });
                if(from_v3) return;
                await dispatch('readQeEvaluateResult', { company_id, campaign_id, project_code, sub_code });
            } catch (error) {
                console.log(error);
                throw error;
            }
        },
        async getFigureBenchmark ({ commit }, { company_id, campaign_id, project_code }) {
            try {
                const response = await axios.get('/get_figure_benchmark', {
                    params: { company_id, campaign_id, project_code }
                });
                
                const _key_figures = response.data;
                for (const _figures in _key_figures) {
                    let _key_figure = _key_figures[_figures];
                    _key_figure = _key_figure.reduce((_transformed, _ele) => {
                        if (typeof _ele.my_state === 'object' && !!_ele.my_state) {
                            const listOfFY = Object.keys(_ele.my_state).filter(_field => _field.includes('FY'));
                            if (Array.isArray(listOfFY)) {
                                for (const _eleOfFY of listOfFY) {
                                    const _removed = thousandSepratorRemover(_ele.my_state[_eleOfFY]);
                                    _ele.my_state[_eleOfFY] = _removed === 'NA' ? '' : _removed;
                                }
                            }
                        }
                        _transformed.push(_ele);
                        return _transformed;
                    }, []);
                    _key_figures[_figures] = _key_figure;
                }

                commit('update_key_figures', _key_figures);
                commit('update_key_figure_loaded', true);
            } catch (error) {
                console.log(' ~ error => ', error);
                console.log(' ~ error.response => ', error.response);
            }
        },
        async checkTaxonomyAccepted ({ commit }, { company_id, campaign_id }){
            const response = await axios.get('/check_taxonomy_accepted', {params: {company_id: company_id, campaign_id: campaign_id}});
            commit('update_check_taxonomy', response.data.accepted);
        },
        async readQeCrHistory ({ commit }, { company_id, campaign_id, project_code }) {
            const response = await axios.get('/read_qe_cr_history', {
                params: { company_id, campaign_id, project_code }
            });

            if (response.data.code !== 'failure') {
                let result = response.data.history_set;
                // 스코어 업데이트 
                commit('update_category1_score', result.category1_score);
                commit('update_category2_score', result.category2_score);

                if (result.category3_score !== null) {
                    commit('update_category3_score', result.category3_score);
                }

                commit('update_total_score', result.total_score[0].total_score);
                commit('update_total_score_object', result.total_score[0]);
                commit('update_bm_distribution', result.benchmark);
                
                // 우수&미흡 factors 업데이트
                commit('update_qe_factors', result.factors_obj);
                
                // 중요성 정보 업데이트
                commit('update_questions_materiality', result.materiality_obj);
                commit('update_materiality_loaded', true);
            }
        },
        async readScoreHistory({ commit }, { company_id, campaign_id, real_time }) {
            try {
                const response = await axios.get('/read_score_history', {
                    params: { company_id, campaign_id, real_time }
                });
                commit('update_score_history', response.data);
                commit('update_score_history_loaded', true);   
            } catch (error) {
                if (error.response) {
                    if (error.response.status !== 404) {
                        return Promise.reject(error);
                    } else {
                        console.log(' ~ error.response => ', error.response);
                    }   
                }
            }
        },
        async readQeCrRisks ({ commit }, { company_id, campaign_id }) {
            try {
                const response = await axios.get('/scores/risk', {
                    params: { company_id, campaign_id }
                });
                if(response.data.code =='success'){
                    commit('update_qe_risks', response.data);
                }
            } catch (error) {
                console.log(error);
            }
        },
        async readQeCrRiskHistory ({ commit }, { company_id, campaign_id }) {
            try {
                const response = await axios.get('/scores/risk/view', {
                    params: { company_id, campaign_id }
                });
                if(response.data.code =='success'){
                    commit('update_qe_risks', response.data);
                }
            } catch (error) {
                console.log(error);
            }
        },
    }
};

export default industry_scores;
